import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class ChannelsUtilityService extends BaseService {
  constructor() {
    super(constants.GET_CHANNELS_DATA, 'channelsUtilityStatus');
  }

  handleEvent(eventName, event) {
    return this.getClient('evergreen').post(`/channels/table`, event.payload);
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success') {
      const dataExist = data?.data?.data?.length > 0 || data?.data?.length > 0;
      const notification = {
        open: true,
        type: dataExist ? 'success' : 'info',
        message: dataExist ? 'Data Fetched Successfully' : 'No Data Found'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('channelsUtility').setResponse(response.data);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    Framework.getStoreRegistry().getStore('channelsUtility').resetStoreValues();
  }
}
